const customShadows = {
  main: '0px 1px 0px 0px rgba(0, 0, 0, 0.2)',
};

export default customShadows;
